import http from "../http-common";

class RoutesDataService {
  getAllPartnerships(){
    return http.get("/routes/getPartnerships");
  }
  getPilgrimagePathList(partnershipSlug: string, pilgrimPathSlugsList: Array<string>) {
    const body = {
      partnershipSlug: partnershipSlug,
      pilgrimPathSlugsList: pilgrimPathSlugsList || []
    }
    return http.post("/routes/getPilgrimPathList", body);
  }
  getStageList(partnershipSlug: string, pilgrimPathSlug: string, stageSlugsList: Array<string>) {
    const body = {
      partnershipSlug: partnershipSlug,
      pilgrimPathSlug: pilgrimPathSlug,
      stageSlugsList: stageSlugsList
    }    
    return http.post("/routes/getStageList", body);
  }
}

export default new RoutesDataService();
